<template>
    <div class="guide-welcome">
        <mvtPicture v-if="getHeroImgWebp" :src="getHeroImage" :srcset="getHeroImgWebp" :alt="alt" />
        <img v-else :src="getHeroImage" :alt="alt" />
        <div class="mask"></div>
        <div class="content">
            <div v-if="article">
                <div v-if="article.categories && article.categories.length">
                    In
                    <a class="cat-link f7" :href="glb.appUrl + 'guide/' + item.url" v-for="item in article.categories">
                        {{item.name}}
                    </a>
                </div>
                <h1 class="title">{{article.title}}</h1>
                <div>{{article.description}}</div>
            </div>
            <div v-else-if="hub">
                <h1 class="f3 text-bold">{{hub.title}}</h1>
                <div class="f7">{{hub.subtitle}}</div>
                <div class="sitemap-link">
                    <a v-if="hub.msp" :href="glb.appUrl + hub.msp" class="btn primary regular">Listings</a>
                    <a v-if="hub.trends" :href="glb.appUrl + hub.trends" class="btn secondary regular">
                        Market Trends
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script src="./guide-welcome.js"></script>

<style lang="scss">
@use "./guide-welcome.scss" as *;
</style>
